// Replaces the N separate cart rows that belong to one combo purchase
// (matched via the hidden "_combo_group" line item property) with a single
// custom card: one image, one title, one total price, a compact list of
// the chosen colors/sizes, and one quantity control that can only be
// INCREASED (adds another full combo set) - it can never be decreased,
// so a customer can never end up with a broken partial quantity like 4 or
// 5 out of a "Pick Any 6". The only way to remove a combo is the delete
// button, which removes the whole set at once.
// The real underlying line items are untouched (just hidden), so Shopify
// still tracks inventory correctly per exact variant - this only changes
// what the customer sees.
(function () {
  var ROW_SELECTORS = [
    '[data-cart-item]',
    '[data-cart-items] > *',
    'cart-items > *',
    'tr',
    'li',
    '.cart-item',
    '.cart__row'
  ];

  var running = false;
  var debounceTimer = null;

  function collectRows() {
    for (var i = 0; i < ROW_SELECTORS.length; i++) {
      var candidates = Array.prototype.filter.call(
        document.querySelectorAll(ROW_SELECTORS[i]),
        function (el) {
          return (
            el.querySelector('input[name="updates[]"], input[type="number"], input[name*="quantity"]') &&
            el.textContent.trim().length > 0
          );
        }
      );
      if (candidates.length > 0) return candidates;
    }
    return [];
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function increaseGroup(cart, indices) {
    // Adding another full combo set = increase every line in the group by
    // its own original per-set quantity (1, since each real variant line
    // represents exactly one piece of that color/size within one combo).
    var updates = {};
    indices.forEach(function (idx) {
      var item = cart.items[idx];
      updates[item.key] = item.quantity + 1;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      window.location.reload();
    });
  }

  function decreaseGroup(cart, indices) {
    var first = cart.items[indices[0]];
    if (first.quantity <= 1) return; // never below 1 full combo set
    var updates = {};
    indices.forEach(function (idx) {
      var item = cart.items[idx];
      updates[item.key] = item.quantity - 1;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      window.location.reload();
    });
  }

  function removeGroup(cart, indices) {
    var updates = {};
    indices.forEach(function (idx) {
      updates[cart.items[idx].key] = 0;
    });
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      window.location.reload();
    });
  }

  function buildCard(cart, indices) {
    var items = indices.map(function (idx) { return cart.items[idx]; });
    var first = items[0];
    var comboLabel = (first.properties || {})['_combo_label'] || 'Combo';
    var total = items.reduce(function (sum, it) { return sum + it.final_line_price; }, 0);
    var setsBought = first.quantity; // how many full combo sets (each line's own quantity)

    var card = document.createElement('div');
    card.className = 'combo-card';

    var img = document.createElement('img');
    img.className = 'combo-card__image';
    img.src = first.image || '';
    img.alt = first.product_title;
    card.appendChild(img);

    var body = document.createElement('div');
    body.className = 'combo-card__body';

    var title = document.createElement('div');
    title.className = 'combo-card__title';
    title.textContent = first.product_title;
    body.appendChild(title);

    var sub = document.createElement('div');
    sub.className = 'combo-card__sub';
    sub.textContent = comboLabel + (setsBought > 1 ? '  x' + setsBought : '');
    body.appendChild(sub);

    var list = document.createElement('div');
    list.className = 'combo-card__items';
    items.forEach(function (it) {
      var pill = document.createElement('span');
      pill.className = 'combo-card__pill';
      pill.textContent = it.variant_title || it.title;
      list.appendChild(pill);
    });
    body.appendChild(list);

    var footer = document.createElement('div');
    footer.className = 'combo-card__footer';

    var qtyBox = document.createElement('div');
    qtyBox.className = 'combo-card__qty';
    var minusBtn = document.createElement('button');
    minusBtn.type = 'button';
    minusBtn.textContent = '−';
    minusBtn.disabled = setsBought <= 1; // floor at 1 full combo set, not fully locked
    minusBtn.addEventListener('click', function () { decreaseGroup(cart, indices); });
    var qtyVal = document.createElement('span');
    qtyVal.textContent = setsBought;
    var plusBtn = document.createElement('button');
    plusBtn.type = 'button';
    plusBtn.textContent = '+';
    plusBtn.title = 'Add one more full combo set';
    plusBtn.addEventListener('click', function () { increaseGroup(cart, indices); });
    qtyBox.appendChild(minusBtn);
    qtyBox.appendChild(qtyVal);
    qtyBox.appendChild(plusBtn);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'combo-card__remove';
    removeBtn.setAttribute('aria-label', 'Remove this combo');
    removeBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M4 7h16" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '<path d="M9 7V4.8c0-.44.36-.8.8-.8h4.4c.44 0 .8.36.8.8V7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M6 7l.8 12.2c.05.98.86 1.75 1.84 1.75h6.72c.98 0 1.79-.77 1.84-1.75L18 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M10 11v6M14 11v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '</svg>';
    removeBtn.addEventListener('click', function () { removeGroup(cart, indices); });

    var price = document.createElement('div');
    price.className = 'combo-card__price';
    price.textContent = formatMoney(total);

    footer.appendChild(qtyBox);
    footer.appendChild(removeBtn);
    footer.appendChild(price);
    body.appendChild(footer);

    card.appendChild(body);
    return card;
  }

  function groupCombos() {
    if (running) return;
    running = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var rows = collectRows();
        if (!rows.length || rows.length !== cart.items.length) {
          running = false;
          return;
        }

        var groups = {};
        cart.items.forEach(function (item, idx) {
          var gid = item.properties && item.properties['_combo_group'];
          if (!gid) return;
          groups[gid] = groups[gid] || [];
          groups[gid].push(idx);
        });

        Object.keys(groups).forEach(function (gid) {
          var indices = groups[gid];
          if (indices.length < 2) return;

          var anchor = rows[indices[0]];
          if (anchor.dataset.comboCardBuilt === '1') return; // already replaced

          indices.forEach(function (idx) {
            rows[idx].style.display = 'none';
          });

          var card = buildCard(cart, indices);
          anchor.parentNode.insertBefore(card, anchor);
          anchor.dataset.comboCardBuilt = '1';
        });

        running = false;
      })
      .catch(function () {
        running = false;
      });
  }

  function scheduleGroup() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(groupCombos, 400);
  }

  document.addEventListener('DOMContentLoaded', scheduleGroup);
  var observer = new MutationObserver(scheduleGroup);
  observer.observe(document.body, { childList: true, subtree: true });
})();